import { useContext, type ComponentProps } from "react";
import { Command as CommandPrimitive } from "cmdk";

import { SelectCollectingContext } from "./SelectContext";

export type SelectGroupProps = ComponentProps<typeof CommandPrimitive.Group>;

export const SelectGroup = ({ children, ...props }: SelectGroupProps) => {
  const collecting = useContext(SelectCollectingContext);
  if (collecting) return <>{children}</>;

  return (
    <CommandPrimitive.Group data-slot="select-group" {...props}>
      {children}
    </CommandPrimitive.Group>
  );
};
